<template>
  <HeaderWarningPanel :visible="daysLeft !== null && daysLeft >= 0 && daysLeft <= 3"
                       :link-to="rights.includes('billing') && canProlong ? '/billing' : null"
                       :link-text="$t('prolong')">
    {{ $tc('tariff_payment_expires_in_days', daysLeft, { day: daysLeft }) }}.
  </HeaderWarningPanel>
</template>

<script setup>
import {computed} from "vue"
import {useStore} from "vuex"
import moment from "moment"
import HeaderWarningPanel from "@/components/parts/general/HeaderWarningPanel.vue"

const store = useStore()

const clinic = computed(() => store.state.auth.clinic)
const rights = computed(() => store.state.auth.rights)
const paidTill = computed(() => {
  if(!clinic.value || !clinic.value.clinic_tariff) return null
  return clinic.value.clinic_tariff.paid_till
})
const canProlong = computed(() => !clinic.value?.clinic_tariff?.tariff?.billing_turned_off)
const daysLeft = computed(() => {
  if(!paidTill.value) return null
  const now = moment()
  return Math.ceil(moment(paidTill.value).diff(now, 'days', true))
})
</script>
